import { ChipMetadata, Tooltip } from '@pmi/dsm-react';
import { AlertInfoIcon } from '@pmi/dsm-react/dist/components/icons/fa/16';

export default function UnavailableChipMetadata() {
  return (
    <Tooltip
      type="sm"
      content="This product is no longer offered. Please contact your PMI account team for more information."
      placement="top"
      className="darkTooltip d-flex "
    >
      <ChipMetadata
        className="me-2"
        text="Unavailable"
        icon={<AlertInfoIcon fontSize="xs" />}
        variant="tangerine"
      />
    </Tooltip>
  );
}
